// AccountAddDialog.tsx
import { DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { toast } from '../ui/toast/use-toast';
import { AccountAddForm } from './account-add-form';
import { Account } from '@liquidbudget/common';

interface Props {
  account?: Account;
  onClose: () => void;
}

export function AccountAddDialogContent({ account, onClose }: Props) {
  const onSuccess = () => {
    onClose();
    toast({
      title: 'Success',
      description: `Your account has been ${account ? 'updated' : 'created'}`,
    });
  };

  return (
    <DialogContent onInteractOutside={(e) => e.preventDefault()}>
      <DialogHeader>
        <DialogTitle>{account ? 'Edit Account' : 'Add Account'}</DialogTitle>
      </DialogHeader>
      <DialogDescription>
        Accounts represent your real-world money sources like bank accounts, credit cards, and cash. They track your
        actual balances so you can distribute them to your buckets.
      </DialogDescription>
      <AccountAddForm account={account} onSuccess={onSuccess} />
    </DialogContent>
  );
}
